import { supabase } from '@/config/supabase'
import type { NoticiaPortal, UUID } from '@/types/database'

export const noticiaService = {
    async list(): Promise<NoticiaPortal[]> {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_noticias_portal')
            .select('*')
            .is('deleted_at', null)
            .order('ordem')

        if (error) throw error
        return (data || []) as unknown as NoticiaPortal[]
    },

    async get(id: UUID): Promise<NoticiaPortal> {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_noticias_portal')
            .select('*')
            .eq('id', id)
            .single()

        if (error) throw error
        return data as unknown as NoticiaPortal
    },

    async create(input: Partial<NoticiaPortal>) {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_noticias_portal')
            .insert(input as any)
            .select()
            .single()

        if (error) throw error
        return data as unknown as NoticiaPortal
    },

    async update(id: UUID, input: Partial<NoticiaPortal>) {
        const { data, error } = await supabase
            .schema('veicular_system')
            .from('veic_noticias_portal')
            // @ts-ignore
            .update(input as any)
            .eq('id', id)
            .select()
            .single()

        if (error) throw error
        return data as unknown as NoticiaPortal
    },

    async remove(id: UUID) {
        const { error } = await supabase
            .schema('veicular_system')
            .from('veic_noticias_portal')
            // @ts-ignore
            .update({ deleted_at: new Date().toISOString() } as any)
            .eq('id', id)

        if (error) throw error
    }
}
